// web/src/api/pause.ts
//
// Best-effort POST /api/sessions/:id/pause — audit-only signal that the
// player tapped the mic to pause. The actual cancellation of in-flight
// turn processing happens via fetch AbortController (see card.ts's
// pauseAbort wired into postTurn). This call is fire-and-forget; any
// error is swallowed so the pause UI is never blocked on the network.

import { withCSRF } from "./_csrf.js";

export async function postPause(sessionId: string): Promise<void> {
  try {
    await fetch(`/api/sessions/${encodeURIComponent(sessionId)}/pause`, {
      method: "POST",
      credentials: "include",
      headers: withCSRF(),
    });
  } catch {
    // Best-effort — silent fail. The client-side abort already stopped
    // any in-flight processing; this endpoint is purely audit.
  }
}
